module.exports = __webpack_public_path__ + "img/bg_image_3.e59840a0.png";